module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"signIn":"Sign in"}}')
  delete Component.options._Ctor
}
